"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultInterruptActions = exports.InterruptActionsBuilder = void 0;
var AutoModuleHelpers_1 = require("../autoModule/AutoModuleHelpers");
var InterruptActionsBuilder = /** @class */ (function () {
    function InterruptActionsBuilder(model) {
        var _this = this;
        this.actions = [];
        this.createActionFor = function (componentName) {
            var _a;
            _this.actions = _this.buildActions();
            _this.curComponent = componentName
                ? (_a = _this.model.getComponent(componentName)) === null || _a === void 0 ? void 0 : _a.component
                : undefined;
            _this.curComponentName = componentName;
            _this.tableRowId = undefined;
            _this.tableRowCol = undefined;
            _this.tableCellPath = undefined;
            return _this;
        };
        this.addActionIfEnabled = function (actionValue) {
            if (!_this.curComponentName || !_this.curComponent)
                return _this;
            if (!_this.isActionValueAcceptable(_this.curComponent, actionValue))
                return _this;
            var payload = {
                tabId: _this.curComponent.tabs[0],
                value: actionValue,
            };
            if (_this.curComponent.category === "table") {
                if (!_this.tableCellPath)
                    return _this;
                payload = __assign(__assign({}, payload), { path: "".concat(_this.curComponent.group, ".").concat(_this.curComponent.name, ".").concat(_this.tableCellPath), rowId: _this.tableRowId });
            }
            else {
                payload = __assign(__assign({}, payload), { path: "".concat(_this.curComponent.group, ".").concat(_this.curComponent.name) });
            }
            _this.actions.push({
                validFor: true,
                action: {
                    type: "[FORM] SUBMIT",
                    payload: payload,
                },
            });
            return _this;
        };
        this.addActionIfDisabled = function (actionValue) {
            if (!_this.curComponentName || !_this.curComponent)
                return _this;
            if (!_this.isActionValueAcceptable(_this.curComponent, actionValue))
                return _this;
            var payload = {
                tabId: _this.curComponent.tabs[0],
                value: actionValue,
            };
            if (_this.curComponent.category === "table") {
                if (!_this.tableCellPath)
                    return _this;
                payload = __assign(__assign({}, payload), { path: "".concat(_this.curComponent.group, ".").concat(_this.curComponent.name, ".").concat(_this.tableCellPath), rowId: _this.tableRowId });
            }
            else {
                payload = __assign(__assign({}, payload), { path: "".concat(_this.curComponent.group, ".").concat(_this.curComponent.name) });
            }
            _this.actions.push({
                validFor: false,
                action: {
                    type: "[FORM] SUBMIT",
                    payload: payload,
                },
            });
            return _this;
        };
        this.setPathToTableCell = function (rowIndex, colName) {
            var _a;
            if (((_a = _this.curComponent) === null || _a === void 0 ? void 0 : _a.category) !== "table")
                return _this;
            _this.tableRowId = rowIndex;
            _this.tableRowCol = colName;
            _this.tableCellPath = "".concat(rowIndex, ".").concat(colName);
            return _this;
        };
        this.isActionValueAcceptable = function (component, actionValue) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (component.category === "hardware") {
                if (component.type === "ComboBox") {
                    var options = (_a = (0, AutoModuleHelpers_1.getSettingFromComponent)(_this.model, component)) === null || _a === void 0 ? void 0 : _a.options;
                    if (!(options === null || options === void 0 ? void 0 : options.some(function (option) {
                        var _a;
                        return option[(_a = component["displayOptionSetting"]) !== null && _a !== void 0 ? _a : "alias"] ===
                            actionValue;
                    }))) {
                        return false;
                    }
                }
                else if (component.type === "boolean") {
                    // if (actionValue !== "enabled" && actionValue !== "disabled") {
                    if (actionValue !== true && actionValue !== false) {
                        return false;
                    }
                }
            }
            else if (component.category === "software") {
                if (component.type === "ComboBox") {
                    var options = component["options"];
                    if (!(options === null || options === void 0 ? void 0 : options.some(function (option) { return option === actionValue; }))) {
                        return false;
                    }
                }
                else if (component.type === "boolean") {
                    if (actionValue !== true && actionValue !== false) {
                        return false;
                    }
                }
            }
            else if (component.category === "table") {
                if (!_this.tableRowCol)
                    return false;
                if (((_c = (_b = component.columns) === null || _b === void 0 ? void 0 : _b[_this.tableRowCol]) === null || _c === void 0 ? void 0 : _c.type) === "ComboBox") {
                    var options = (_f = (_e = (_d = component.columns) === null || _d === void 0 ? void 0 : _d[_this.tableRowCol]) === null || _e === void 0 ? void 0 : _e.defaultValue) === null || _f === void 0 ? void 0 : _f["options"];
                    if (!(options === null || options === void 0 ? void 0 : options.some(function (option) { return option === actionValue; }))) {
                        return false;
                    }
                }
                else if (((_h = (_g = component.columns) === null || _g === void 0 ? void 0 : _g[_this.tableRowCol]) === null || _h === void 0 ? void 0 : _h.type) === "boolean") {
                    if (actionValue !== true && actionValue !== false) {
                        return false;
                    }
                }
            }
            return true;
        };
        this.buildActions = function () {
            return _this.actions;
        };
        this.model = model;
    }
    InterruptActionsBuilder.createActionBuilder = function (model) {
        return new InterruptActionsBuilder(model);
    };
    return InterruptActionsBuilder;
}());
exports.InterruptActionsBuilder = InterruptActionsBuilder;
function getDefaultInterruptActions(model, componentName) {
    if (!componentName)
        return [];
    return (InterruptActionsBuilder.createActionBuilder(model)
        .createActionFor(componentName)
        .addActionIfEnabled(true)
        .addActionIfDisabled(false)
        // .addActionIfEnabled("enabled")
        // .addActionIfDisabled("disabled")
        .buildActions());
}
exports.getDefaultInterruptActions = getDefaultInterruptActions;
//# sourceMappingURL=InterruptActions.js.map